export const MONTH_KEYS = [
  "common.months.january",
  "common.months.february",
  "common.months.march",
  "common.months.april",
  "common.months.may",
  "common.months.june",
  "common.months.july",
  "common.months.august",
  "common.months.september",
  "common.months.october",
  "common.months.november",
  "common.months.december",
] as const;
